export default __webpack_public_path__ + "static/media/loginimg.341658f5.png";